// resources/js/admin/pages/module-pages/pages/UpdatePagePage.tsx

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Page, PageFormData } from "../../../types/features/Page";
import PageForm from "../../../components/shared/pages/PageForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import useCustomParams from "../../../hooks/core/useCustomParams";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import { useProduct } from "../../../hooks/core/useProduct";
import usePages from "../../../hooks/features/pages/usePages";

export default function UpdatePagePage() {
    const { id } = useCustomParams();
    const navigate = useNavigate();
    const { selectedProduct } = useProduct();
    const { fetchPageById, updatePage } = usePages(selectedProduct || "izi-call");
    const [page, setPage] = useState<Page | null>(null);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        loadPage();
    }, [id]);

    const loadPage = async () => {
        if (id) {
            const data = await fetchPageById(id);
            if (data) {
                setPage(data);
            }
            setLoading(false);
        }
    };

    const handleSubmit = async (data: PageFormData): Promise<any> => {
        setIsLoading(true);
        try {
            const updatedPage = await updatePage(id!, data);
            console.log("data" , data)

            if (updatedPage) {
                setIsSuccess(true);
                alertSuccess("Page mise à jour avec succès");
                navigate("/admin/pages");
                return updatedPage;
            } else {
                alertError("Erreur lors de la mise à jour de la page");
                return null;
            }
        } catch (error) {
            alertError("Erreur lors de la mise à jour de la page");
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (!page) {
        return (
            <div className="flex flex-col items-center justify-center h-64">
                <p className="text-gray-500">Page non trouvée</p>
                <button
                    onClick={() => navigate("/admin/pages")}
                    className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
                >
                    Retour à la liste
                </button>
            </div>
        );
    }

    return (
        <PageLayout title="Modifier la page" className="p-6 max-w-4xl mx-auto">
            <PageContainer>
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Modifier la page</h1>
                    <p className="text-gray-500 mt-1">
                        Modifiez les informations de la page "{page.name || page.slug_key}"
                    </p>
                </div>
                <PageForm
                    siteSlug={selectedProduct || "izi-call"}
                    initialData={page}
                    isEdit={true}
                    isSuccess={isSuccess}
                    onSubmit={handleSubmit}
                    isLoading={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}